import { t } from "@/i18n-js/instance";
import { formatPaywallCurrencyAmount } from "@/react/helpers/paywalls/currencies";
import { mapCurrencyAmountStrToInt } from "@circle-react/components/Paywalls/Admin/utils";
import { paywallPriceTypes } from "@circle-react/types/PaywallPrice";
import type {
  NoticeScenario,
  NoticeScenarioMatcher,
  NoticeScenarioMessagePropsResolver,
} from "../NoticeScenario.types";
import { localeRoot } from "../constants";
import { recurringStateValidator } from "./StateValidators";

const matcher: NoticeScenarioMatcher = ({
  priceType,
  hasUpfrontPayment,
  hasTrialPeriod,
}) =>
  priceType === paywallPriceTypes.subscription &&
  !hasUpfrontPayment &&
  hasTrialPeriod;
const messagePropsResolver: NoticeScenarioMessagePropsResolver = ({
  buildOptions,
  currency,
  trialPeriodDays,
  watch,
}) => {
  const member_free_trial_phrase = t(
    [localeRoot, "phrases", "member_free_trial"],
    {
      count: trialPeriodDays,
    },
  );

  return [
    ["trial_then_subscription"],
    {
      member_free_trial_phrase,
      recurring_frequency:
        buildOptions.frequencies[
          watch("billing_frequency")
        ].as_phrase.toLowerCase(),
      recurring_amount: formatPaywallCurrencyAmount(
        currency,
        mapCurrencyAmountStrToInt(watch("amount")),
        {
          amountInCents: true,
          includeCurrencyCode: true,
        },
      ),
    },
  ];
};

export const trialThenSubscription: NoticeScenario = {
  matcher,
  stateValidator: recurringStateValidator,
  messagePropsResolver,
};
